import { Link } from 'react-router-dom';
import { Badge } from '@/components/ui/Badge';
import { Button } from '@/components/ui/Button';
import { SectionCta } from '@/features/public-pages';
import type { ServiceCtaSpec } from '../../command-center-ctas';
import { dataRoomHandoffHref } from '../../data-room-links';
import { COMMAND_CENTER_SERVICES as S } from '../../constants';
import type { ServiceCtaContent } from './service-content';

export interface ServiceCtaProps {
  spec: ServiceCtaSpec;
  /** The section's own CMS call to action, used for buy and schedule. */
  content: ServiceCtaContent;
  startupId: string | null;
}

/**
 * One service's call to action, as the state decides. Buy and schedule are the
 * public page's own CTA, so the Issue Report keeps its "Coming Soon" state and
 * purchase journey, and the scheduler keeps opening in a new tab.
 */
export function ServiceCta({ spec, content, startupId }: ServiceCtaProps) {
  switch (spec.kind) {
    case 'buy':
      return content.ctaLabel ? (
        <SectionCta label={content.ctaLabel} url={content.ctaUrl} offerCta={content.offerCta} />
      ) : null;
    case 'schedule':
      return content.ctaLabel ? (
        <SectionCta
          label={content.ctaLabel}
          url={content.ctaUrl}
          openInNewTab={content.ctaOpensInNewTab}
        />
      ) : null;
    case 'open':
      return startupId ? (
        <Button asChild variant="primary" className="w-fit">
          <Link to={dataRoomHandoffHref(startupId)} target="_blank" rel="noopener noreferrer">
            {spec.label}
            <span className="sr-only"> {S.NEW_TAB}</span>
          </Link>
        </Button>
      ) : null;
    case 'status':
      return <Badge variant="neutral">{spec.label}</Badge>;
    case 'none':
      return null;
  }
}
